import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { IconButton, Tooltip } from '@mui/material';
import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';

const CopyButton = function CopyButton({ text = '' }) {
  const intl = useIntl();
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return undefined;
    const timeout = setTimeout(() => setCopied(false), 1500);
    return () => clearTimeout(timeout);
  }, [copied]);

  const handleCopy = async (e) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(text ?? '');
      setCopied(true);
    } catch {
      /* clipboard refused (insecure origin or permission): nothing to report */
    }
  };

  return (
    <Tooltip
      title={copied ? intl.messages.COPIED : intl.messages.COPY_TO_CLIPBOARD}
    >
      <IconButton size="small" onClick={handleCopy} sx={{ flexShrink: 0 }}>
        {copied ? (
          <CheckRoundedIcon fontSize="small" color="success" />
        ) : (
          <ContentCopyRoundedIcon
            fontSize="small"
            sx={{ color: 'text.secondary' }}
          />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default CopyButton;
